import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { show as showSuccessModal } from '@/components/success-modal'

const useStopPadSuccessModal = (): { show: () => void } => {
  const { t } = useTranslation()
  const show = useCallback(() => {
    showSuccessModal({
      title: t('r.pad_settings.edit.pad_stopped.confirm.heading', 'PAD Payment Stopped!'),
      message: t(
        'r.pad_settings.edit.pad_stopped.confirm.text',
        'Your automatic rent payments have been stopped. Note that it may take up to 30 days for this to be processed.'
      ),
      buttonText: t('r.pad_settings.edit.pad_stopped.confirm.button', 'Got it')
    })
  }, [t])
  return { show }
}

export default useStopPadSuccessModal
